import { Type } from "@angular/core";

import { CreateEditRuleComponent } from "./create-edit-rule.component";
import {FilterLabelComponent} from "./filter-label.component";

export const CREATE_EDIT_RULE_DIRECTIVES: Type<any>[] = [
  CreateEditRuleComponent,
  FilterLabelComponent
];
